import React, { useEffect, useMemo, useState } from "react";
import { Proposal, Role, SlotStatus } from "../types";
import { format } from "../utils";
import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/solid";

type Props = {
  title: string;
  proposals: Proposal[];
  role: Role;
  onAccept: (proposalId: string, index: number) => void;
  onDecline: (proposalId: string, index: number) => void;
};

export const ProposalColumn = ({
  title,
  proposals,
  role,
  onAccept,
  onDecline,
}: Props) => {
  return (
    <div className="flex-1 border rounded p-3">
      <h3 className="font-bold mb-2">{title}</h3>

      {proposals.map((p) => (
        <div key={p.id} className="mb-3 border-b pb-2">
          <div className="text-xs text-gray-500 mb-1">
            Iteration {p.iteration}
          </div>

          {p.slots.map((s, i) => {
            const isMyProposal = p.proposedBy === role;
            const isPending = s.status === "pending";

            return (
              <div
                key={i}
                className="flex items-center justify-between text-sm py-1"
              >
                <span>
                  {format(s.slot)} ({s.status})
                </span>

                {/* ACTIONS */}
                {!isMyProposal && isPending && (
                  <div className="flex gap-2">
                    <button
                      onClick={() => onAccept(p.id, i)}
                      className="text-green-600"
                      title="Accept"
                    >
                      <CheckCircleIcon className="w-5 h-5" />
                    </button>

                    <button
                      onClick={() => onDecline(p.id, i)}
                      className="text-red-600"
                      title="Decline"
                    >
                      <XCircleIcon className="w-5 h-5" />
                    </button>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};